module.exports = __webpack_public_path__ + "da57c092acfaa0247e21bb11742f2959.png";